import React, { useState, useEffect } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';

const SalesManEdit = () => {
    const { id: recordId } = useParams(); // Use useParams to get the ID
    const history = useHistory();
    const { isAuthenticated, userId, logout, token } = useAuth();
    const [formData, setFormData] = useState({ Name: '' });
    const [error, setError] = useState(null);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, token, logout]);

    useEffect(() => {
        const fetchSalesMan = async () => {
            try {
                const response = await fetchData('SalesManApi', `/SalesMan/${recordId}`, token);
                if (response.responseCode === '1111') {
                    setFormData(prevData => ({
                        ...response.response_data,
                        UpdatedBy: userId,
                    }));
                } else {
                    setError('Failed to fetch sales man details.');
                }
            } catch (error) {
                setError('Error fetching Sales Man Details');
                console.error(error);
            }
        };
        fetchSalesMan();
    }, [recordId, token, userId]);

    const handleChange = event => {
        const { name, value } = event.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async event => {
        event.preventDefault();
        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        try {
            await updateData('SalesManApi', `${recordId}`, formData, token);
            history.push('/SalesManIndex');
        } catch (error) {
            setError('Error updating record.');
            console.error(error);
        }
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            {error && <div className="text-red-500">{error}</div>}
            <form onSubmit={handleSubmit}>
                <div className='w-full mb-2 flex items-center'>
                    <h5 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}> Sales Man - Edit</h5>
                    <Button
                        variant="contained"
                        style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                        type="submit"
                    >
                        UPDATE
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        component={Link}
                        to="/SalesManIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px' }}
                    >
                        CANCEL
                    </Button>
                </div>
                <div>
                    <div className="w-full mb-4 flex">
                        <div className="w-4/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Sales Man Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Name}
                                onChange={handleChange}
                                name='Name'
                                type="text"
                                placeholder="Enter Name"
                                required
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default SalesManEdit;
